module.exports = __webpack_public_path__ + "1_0_58/img/default.7dfbaa24.jpg";